import React from 'react'
import ContactForm from '../components/ContactForm'
import Container from '../components/Container'
import Title from '../components/Title'

import { ReactComponent as Phone } from '../assets/svg/phone.svg'
import { ReactComponent as Email } from '../assets/svg/email.svg'

function Contact() {
    return (
        <div className={`relative bg-[url('assets/images/contactBg.png')] flex items-center`} id="contact-us">
            <div className='bg-black opacity-70 absolute top-0 left-0 w-full h-full'></div>
            <div className='w-full z-10 py-20'>
                <Container>
                    <div className='flex flex-col gap-5 mb-10'>

                        <Title className='text-center'>
                            Our Trusted Partners
                        </Title>
                        <div className='text-center text-base md:text-xl text-white'>
                            Collaborating with industry leaders to bring you exceptional service and value.
                        </div>
                    </div>

                    <div className='flex gap-10 flex-col lg:flex-row'>
                        <div className="basis-2/5">
                            <ContactForm redLabelShown={false} />
                        </div>
                        <div className="basis-3/5 flex flex-col">
                            <div className='flex flex-col sm:flex-row gap-5'>
                                <div className='flex gap-4 rounded-[20px] bg-[#ffffff10] p-5 flex-1'>
                                    <div className='flex-none'>
                                        <Phone />
                                    </div>
                                    <a className='block' href='tel:+41 31 312 31 31'>
                                        <p className='md:text-xl font-bold mb-2 text-white'>Phone Number</p>
                                        <span className='text-sm md:text-lg text-white'>+41 31 312 31 31</span>
                                    </a>
                                </div>
                                <div className='flex gap-4 rounded-[20px] bg-[#ffffff10] p-5 flex-1'>
                                    <div className='flex-none'>
                                        <Email />
                                    </div>
                                    <a className='block' href='mailto:contcat@Schliesserk .com'>
                                        <p className='md:text-xl font-bold mb-2 text-white'>Email</p>
                                        <span className='text-sm md:text-lg text-white'>contcat@Schliesserk .com</span>
                                    </a>
                                </div>
                            </div>
                            <div className='pt-5 sm:pt-10 flex-1'>
                                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d43573.73692778988!2d7.3537362926201775!3d46.95464474799163!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x478e39c0d43a1b77%3A0xcb555ffe0457659a!2sBern%2C%20Switzerland!5e0!3m2!1sen!2s!4v1736420093576!5m2!1sen!2s" width="100%" height="100%" style={{ border: 0, borderRadius: '10px' }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade" title='map'></iframe>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </div>
    )
}

export default Contact